import veritoneApi from './veritoneApi';
import { get, flatten} from 'lodash';


function genGetOrgsQuery(offset, limit) {
  return `{
    organizations(kvpProperty: "attribute", kvpValue: "enabled", offset: ${offset}, limit: ${limit}) {  
      records {
        id,
        name,
        imageUrl,
        createdDateTime,
        modifiedDateTime,
        status
      }
    }
  }`
}

function genGetOrgQueryById(id) {
  return `{
    organization(id: ${id}) {
      id
      name
      imageUrl
      createdDateTime
      modifiedDateTime
      status
      roles {
        appName
      }
    }
  }`
}

function genGetOrgWhitelistByOrgId(orgId) {
  return `{
    organization(id: ${orgId}) {
      name
      id
      whitelist {
        engines {
          id
          name
        }
      }
    }
  }`
};

function genGetAttributionEngines(engines) {
  return `{
    engines(ids: ${JSON.stringify(engines)}){
      records{
        id
        name
        isPublic
      }
    }
  }`
};

async function fetchOrganizations(urlApi, fetchFromIndex = 0, fetchLimit = 1000) {
  try {
    const res = await veritoneApi(urlApi.graphql).post(
      '',
      { query: genGetOrgsQuery(fetchFromIndex, fetchLimit) }
    );
  
    const errors = get(res, 'errors');
    if (errors) {
      const errorMessage = get(errors, '[0].message', 'graphQL error');
      throw new Error(errorMessage);
    }

    return get(res, 'data.data.organizations.records', []);
  } catch (error) {
    const errorMessage = get(error, 'Error', 'load orgs api error');
    throw new Error(errorMessage);
  }
};

export async function getAllOrgsApi(urlApi, fetchFromIndex = 0, fetchLimit = 1000, threads = 3, orgs = []) { 
  const promises = [];
  let newFetchIndex = fetchFromIndex;
  for(let count = 0; count < threads; count++) {
    promises.push(fetchOrganizations(urlApi, newFetchIndex, fetchLimit));
    newFetchIndex += fetchLimit;
  }

  const fetchResult = await Promise.all(promises).then(result => {
    return { data: flatten(result) };
  }).catch(error => { 
    return { error };
  });

  if (get(fetchResult, 'error')) {
    return { error: fetchResult.error }
  }

  const allOrgs = [...orgs, ...fetchResult.data];
  if( fetchResult.data.length < fetchLimit * (threads || 1)) {
    return { data: allOrgs };
  } else {
    return getAllOrgsApi(urlApi, newFetchIndex, fetchLimit, threads, allOrgs);
  }
};

export async function fetchAccessibleOrgsApi(urlApi) {
  return veritoneApi(urlApi.baseUrl)
    .get(`/org`)
    .then(response => response.data)
    .catch(error => error);
}

export async function fetchOrgByIdApi(urlApi, id) {
  try {
    const res = await veritoneApi(urlApi.graphql).post(
      '',
      { query: genGetOrgQueryById(id) }
    );
  
    const errors = get(res, 'errors');
    if (errors) {
      const errorMessage = get(errors, '[0].message', 'graphQL error');
      throw new Error(errorMessage);
    }
    return get(res, 'data.data.organization');
  } catch(error) {
    return { error }
  }
};

export function fetchOrgGroupApi(urlApi, groupIds) {  
  return veritoneApi(urlApi.baseUrl)
    .get(`/org/group`)
    .then(response => response.data)
    .catch(error => error);
};

export function updateOrgGroupApi(urlApi, groupInfo) {  
  const {id} = groupInfo;
  return veritoneApi(urlApi.baseUrl)
    .put(`/org/group/${id}`, groupInfo)
    .then(response => response.data)
    .catch(error => error);
};

export function createOrgGroupApi(urlApi, groupInfo) {  
  return veritoneApi(urlApi.baseUrl)
    .post(`/org/group`, groupInfo)
    .then(response => response.data)
    .catch(error => error);
};

export function deleteOrgGroupApi(urlApi, id) {  
  return veritoneApi(urlApi.baseUrl)
    .delete(`/org/group/${id}`)
    .then(response => response.data)
    .catch(error => error);
};

export function loginOrgGroupApi(urlApi, id) {  
  return veritoneApi(urlApi.baseUrl)
    .get(`/org/switch/${id}`)
    .then(response => response.data)
    .catch(error => error);
};

export function rollbackOrgApi(urlApi) {
  return veritoneApi(urlApi.baseUrl)
    .get(`/org/revert`)
    .then(response => response.data)
    .catch(error => error);
}

export async function fetchAttributionEngines(urlApi, engines) {
  try {
    const res = await veritoneApi(urlApi.graphql).post(
      '',
      { query: genGetAttributionEngines(engines)}
    );
    const errors = get(res, 'errors');
    if (errors) {
      const errorMessage = get(errors, '[0].message', 'graphQL error');
      throw new Error(errorMessage);
    }
    return get(res, 'data.data.engines.records');
  } catch (error) {
    return { error };
  }
}
export async function fetchOrgWhitelistByOrgId(urlApi, orgId) {
  try {
    const res = await veritoneApi(urlApi.graphql).post(
      '',
      { query: genGetOrgWhitelistByOrgId(orgId) }
    );
    const errors = get(res, 'errors');
    if (errors) {
      const errorMessage = get(errors, '[0].message', 'graphQL error');
      throw new Error(errorMessage);
    }
    return get(res, 'data.data.organization');
  } catch (error) {
    return { error };
  } 
}
